import { render } from "./AuthLayout.vue?vue&type=template&id=fc8bb87e&bindings={}"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fc8bb87e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc8bb87e')) {
    api.reload('fc8bb87e', script)
  }
  
  module.hot.accept("./AuthLayout.vue?vue&type=template&id=fc8bb87e&bindings={}", () => {
    api.rerender('fc8bb87e', render)
  })

}

script.__file = "resources/js/Pages/Layouts/AuthLayout.vue"

export default script